import { Theme } from '@cointracker/ui';
import { createStore } from 'zustand/vanilla';

interface ThemeState {
  theme: Theme | null;
  setTheme: (theme: Theme | null) => void;
}
export const themeStore = createStore<ThemeState>((set) => ({
  theme: Theme.SYSTEM,
  setTheme: (theme) => set(() => ({ theme })),
}));
